import shuffle from 'lodash/shuffle';
import { ref } from '@nuxtjs/composition-api';
import { useStoryblok } from './useStoryblok';

export function useFetchRelatedArticles() {
  const { storyblok } = useStoryblok();
  const relatedArticles = ref(null);

  async function fetchRelatedArticles({ categoryUuid, articleUuid }) {
    const response = await storyblok.getArticles({ categoryUuid, coverImg: true });
    relatedArticles.value = takeSix(shuffle(removeArticle(response, articleUuid)));
  }

  return {
    relatedArticles,
    fetchRelatedArticles
  };
}

function removeArticle(articles, uuidToRemove) {
  return articles.filter(a => a.uuid !== uuidToRemove);
}

function takeSix(articles) {
  return articles.slice(0, 6);
}
